import InternalAPI from "../../../../../app/axios.js"
import "../types"

/** @borrows InternalAPI */

export default class ListRoute extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/route-sitemap"
        this.locationEndpoint = "v1/route/origin"
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        try {
            const res = await this.$axios.get(this.endpoint + "/admin?" + queries)
            if (res.status === 200) {
                return {data: res.data.data, err: null}
            }
            return {data: [], err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response.data.message.id || "something went wrong")}
        }
    }

    async getLocations(queries) {
        try {
            const res = await this.$axios.get(this.locationEndpoint + "/data?" + queries)
            if (res.status === 200) {
                return {data: res.data.data, err: null}
            }
            return {data: [], err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response  || "something went wrong")}
        }
    }

    async saveOne(payload) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.post(this.endpoint, payload)
            if (res.status === 201) {
                return {err: null}
            }
            return {err: "something went wrong"}
        } catch (err) {
            return { err: this.setErrorMessage(err.response.data.message.id || "something went wrong") };
        }
    }

    /**
     * GET route by ID
     * @param {string|number} id
     */
    async getById(id) {
        try {
            const res = await this.$axios.get(`${this.endpoint}/${id}`);
            if (res.status === 200) {
                return { data: res.data.data, err: null };
            }
            return { data: null, err: "something went wrong" };
        } catch (err) {
            return { data: null, err: this.setErrorMessage(err.response.data.message.id || "something went wrong") };
        }
    }

    async update(id, payload) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.put(`${this.endpoint}/${id}`, payload)
            if ([200, 201, 204].includes(res.status)) {
                return { err: null }
            }
            return { err: "something went wrong" }
        } catch (err) {
            return { err: this.setErrorMessage(err.response.data.message.id || "something went wrong") }
        }
    }
}
